/**
 * Descarga de listados como CSV que abre bien en Excel en español.
 *
 * Tres detalles que hay que respetar o el archivo se ve mal:
 *  - separador punto y coma: con coma, Excel en es-AR mete todo en una columna
 *  - BOM al principio: sin eso los acentos y la ñ salen rotos
 *  - coma decimal: 1234.5 tiene que ir como "1234,5" para que Excel lo tome como número
 *
 * Estaba escrito a mano dentro de Inventario; se saco aca para no repetirlo en cada
 * pantalla que exporta.
 */

/** Encierra el valor entre comillas y escapa las que traiga adentro. */
const escapar = (valor: unknown): string =>
  '"' + String(valor ?? '').replace(/"/g, '""') + '"';

/** Un número como lo espera Excel en español: coma decimal, vacío si no hay dato. */
export const numeroCsv = (valor: unknown): string =>
  valor === null || valor === undefined || valor === ''
    ? ''
    : String(Number(valor)).replace('.', ',');

/** Una fecha como dd/mm/aaaa, en hora local. */
export const fechaCsv = (valor: string | Date | null | undefined): string => {
  if (!valor) return '';
  const d = typeof valor === 'string' ? new Date(valor) : valor;
  if (isNaN(d.getTime())) return '';
  return d.toLocaleDateString('es-AR');
};

/** Fecha y hora, para listados donde importa el momento. */
export const fechaHoraCsv = (valor: string | Date | null | undefined): string => {
  if (!valor) return '';
  const d = typeof valor === 'string' ? new Date(valor) : valor;
  if (isNaN(d.getTime())) return '';
  return d.toLocaleString('es-AR');
};

/**
 * Arma el CSV y dispara la descarga.
 *
 * `nombre` va sin extensión: se le agrega la fecha de hoy y el .csv.
 */
export function descargarCsv(
  nombre: string,
  encabezados: string[],
  filas: (string | number | null | undefined)[][],
): void {
  const lineas = [
    encabezados.map(escapar).join(';'),
    ...filas.map((fila) => fila.map(escapar).join(';')),
  ];

  const contenido = '﻿' + lineas.join('\r\n');
  const blob = new Blob([contenido], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);

  const enlace = document.createElement('a');
  enlace.href = url;
  enlace.download = `${nombre}_${new Date().toISOString().slice(0, 10)}.csv`;
  document.body.appendChild(enlace);
  enlace.click();
  enlace.remove();
  // Firefox necesita que la URL siga viva cuando dispara la descarga
  setTimeout(() => URL.revokeObjectURL(url), 10000);
}
